import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { Form, Input, Button, Row, Col, message} from 'antd';
import 'antd/dist/antd.css';
import '../App.css'

const API_HOST_URL = process.env.REACT_APP_API_URL

class PasswordResetForm extends Component {

    state = {
        confirmDirty: false,
        loading: false
    }
    
    componentDidMount(){
    }
    
    handleFormSubmit = (event)=> {
        event.preventDefault();
        console.log("Reset Password Form submitted!")
        
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                console.log(err);
                    message.warning('Ensure you have filled in your new password.');
                return;
            }
            this.setState({
              loading: true
            })

            // console.log("use values: ", {...this.props.currentUserWithPermissionData} )
            // console.log(values);
            
            axios.put(`${API_HOST_URL}/api/systemsetup/change-password/`, {
              old_password: values.oldpassword,
              new_password: values.password
            },
            {
              headers: {Authorization: 'Token ' + this.props.token}  
          })
        .then(res => {
            this.setState({
              loading: false
            })
            form.resetFields();
            console.log(res)
            message.success("Password changed successfully",10)
        })
        .catch(error =>{
          this.setState({
            loading: false
          })
          form.resetFields();
            console.log(error.response.data)
            message.error(JSON.stringify(error.response.data),10)
            } );
        
    });
}

handleConfirmBlur = (e) => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  }

compareToFirstPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue('password')) {
      callback('Passwords you have entered do not match');
    } else {
      callback();
    }
  }

  validateToNextPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  }


    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <div>
                <h1>Change your password</h1>

                <Form onSubmit={this.handleFormSubmit}>
                    <Row type="flex">

                        <Col span={8} style={{ padding: 6 }}>
                            <Form.Item
                                label="Old Password"
                            >
                                {getFieldDecorator('oldpassword', {
                                    rules: [{
                                        required: true, message: 'Please input your old password!',
                                    }],
                                })(
                                    <Input type="password" />
                                )}
                            </Form.Item>

                            <Form.Item
                                label="New Password"
                            >
                                {getFieldDecorator('password', {
                                    rules: [{
                                        required: true, message: 'Please input your new password!',
                                    }, {
                                        validator: this.validateToNextPassword,
                                    }],
                                })(
                                    <Input type="password" />
                                )}
                            </Form.Item>

                            <Form.Item
                                label="Confirm New Password"
                            >
                                {getFieldDecorator('confirm', {
                                    rules: [{
                                        required: true, message: 'Please confirm your new  password!',
                                    }, {
                                        validator: this.compareToFirstPassword,
                                    }],
                                })(
                                    <Input type="password" onBlur={this.handleConfirmBlur} />
                                )}
                            </Form.Item>
                        </Col>
                    </Row>

                    <Form.Item>
                        <Button loading={this.state.loading} type="primary" htmlType="submit">Set Password</Button>
                    </Form.Item>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isAuthenticated: state.token !== null
    }
}

const Password = Form.create({ name: 'password_reset_form' })(PasswordResetForm)

export default connect(mapStateToProps, null)(Password);

